let isOnline = true;

export const getIsOnline = () =>{
  return isOnline;
}

export const setIsOnline = (value) => {
    isOnline = value;
}